<template>
  <section class="section">
      <div class="columns is-centered">
        <div class="column is-one-third">
          <div class="has-text-centered" style="margin-bottom: 1rem;">
            <span style="font-size: 1.75rem; font-weight: 700; letter-spacing: -0.5px; color: #3273dc;">Fooshi</span>
          </div>
          <div class="has-text-centered" style="margin-bottom: 1.5rem;">
            <LanguageSelector />
          </div>
          <h3 class="title is-4 is-spaced is-centered">
            <span>{{ $t('onboarding.login.title') }}</span>
          </h3>
          <div v-if="$route.query.reset === 'done'" class="notification is-success is-light">
            {{ $t('onboarding.resetPassword.done') }}
          </div>
          <div class="field">
            <label class="label">{{ $t('onboarding.login.email') }}</label>
            <p class="control has-icons-left has-icons-right">
              <input v-focus class="input" type="email" placeholder="Email" autocomplete="email" v-model="loginInfo.email" @change="onLoginInfoChanged"
                  v-bind:class="{
                    'is-danger': view.errors
                  }" />
              <span class="icon is-small is-left">
                <i class="fa fa-envelope"></i>
              </span>
            </p>
          </div>
          <div class="field">
            <label class="label">{{ $t('onboarding.login.password') }}</label>
            <p class="control has-icons-left has-icons-right">
              <input class="input" :type="view.passwordFieldType" placeholder="Password" autocomplete="current-password" v-model="loginInfo.password" @change="onLoginInfoChanged"
                  v-bind:class="{
                        'is-danger': view.errors
                      }"/>
              <span class="icon is-small is-left">
                <i class="fa fa-lock"></i>
              </span>
              <span class="icon is-small is-right">
                <i v-bind:class="{
                  'fa': true,
                  'fa-eye': !view.showPassword,
                  'fa-eye-slash': view.showPassword
                  }"
                  style="pointer-events: all; cursor: pointer"
                  @click="showHidePassword()">
                </i>
              </span>
            </p>
            <p class="help is-danger" v-if="view.errors">
              {{ $t('onboarding.login.passwordIncorrect') }}
            </p>
            <p class="help has-text-right">
              <router-link to="/forgot-password">{{ $t('onboarding.login.forgotPassword') }}</router-link>
            </p>
          </div>
          <div class="field">
            <p class="control">
              <primary-button :label="$t('app.buttons.login')" @click="submit()" class="is-fullwidth" :loading="loading"></primary-button>
            </p>
          </div>
          <div class="tabs is-centered">
            <ul>
              <li class="is-active">{{ $t('onboarding.login.or') }}</li>
            </ul>
          </div>
          <div class="field">
            <p class="control">
              <button class="button is-info is-fullwidth" @click="signUp()">{{ $t('app.buttons.signup') }}</button>
            </p>
          </div>
        </div>
      </div>
  </section>
</template>

<script>

import Auth from '@/auth/auth'
import { FooshiApi } from '@/services/fooshiApi.service'
import PrimaryButton from '../../components/forms/PrimaryButton.vue'
import LanguageSelector from '../../components/LanguageSelector.vue'

export default {
  components: { PrimaryButton, LanguageSelector },
  methods: {
    async submit () {
      this.loading = true
      try {
        const response = await FooshiApi.logIn(this.loginInfo)
        if (response.success) {
          Auth.getInstance().logIn(response)
          if (window.plausible) window.plausible('Login Completed', { props: { stage: 'acquisition' } })
          this.$router.push('/')
        } else {
          this.view.errors = true
          if (window.plausible) window.plausible('Login Failed', { props: { stage: 'acquisition' } })
        }
      } catch (err) {
        if (err.status === 401) {
          this.view.errors = true
          if (window.plausible) window.plausible('Login Failed', { props: { stage: 'acquisition' } })
        } else {
          // todo: generic error
        }
      }
      this.loading = false
    },
    signUp () {
      this.$router.push('/signup')
    },
    onLoginInfoChanged () {
      this.view.errors = false
    },
    showHidePassword () {
      if (this.view.passwordFieldType === 'password') {
        this.view.passwordFieldType = 'text'
      } else {
        this.view.passwordFieldType = 'password'
      }
      this.view.showPassword = !this.view.showPassword
    }
  },
  data () {
    return {
      loading: false,
      ready: false,
      view: {
        errors: false,
        passwordFieldType: 'password',
        showPassword: false
      },
      loginInfo: {
        email: '',
        password: ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/onBoarding/Login.vue